// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"532":"0b621e0a47a5a14e","588":"1c9e8a89d61d5126","789":"68917355d71d097b"}[chunkId] + ".js";
};